<template>
  <div>
    <InputLabel :labelClass="label_class" :forId="id" :label="label" />
    <select
      :id="id"
      :name="name"
      :class="select_class"
      :disabled="is_disabled"
      :required="is_required"
      :value="modelValue"
      v-bind="$attrs"
      @change="$emit('update:modelValue', $event.target.value)"
      class="block text-lg mt-1 flex-1 rounded-3xl border-b bg-transparent border-white/50 px-3 py-1 text-white placeholder:text-gray-300 placeholder:text-[12px] sm:text-sm sm:leading-6 focus:outline-none focus:ring-0 focus:shadow-lg focus:shadow-white/70 transition-shadow duration-500"
    >
      <option v-if="option_placeholder" :value="''" :disabled="option_placeholder_disabled" :selected="option_placeholder_selected">
        {{ option_placeholder }}
      </option>
      <option
        v-for="option in options"
        :key="option[valueKey]"
        :value="option[valueKey]"
        class="text-gray-800 text-sm"
      >
        {{ option[labelKey] }}
      </option>
    </select>
  </div>
</template>

<script>
import InputLabel from "./InputLabel.vue";

export default {
  name: "Select",
  components: {
    InputLabel,
  },
  props: {
    label: String,
    label_class: String,
    id: [String, Number],
    name: String,
    select_class: String,
    modelValue: [String, Number],
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    valueKey: {
      type: String,
      default: "value", // Default key for value
    },
    labelKey: {
      type: String,
      default: "label", // Default key for label
    },
    is_disabled: Boolean,
    is_required: Boolean,
    option_placeholder: String,
    option_placeholder_disabled: {
      type: Boolean,
      default: true,
    },
    option_placeholder_selected: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["update:modelValue"],
  inheritAttrs: false,
};
</script>
